// ABOUTME: Compact horizontal progress bar for displaying workspace usage vs limits.
// ABOUTME: Color-coded by utilization percentage with formatted numbers.

interface UsageProgressBarProps {
  label: string;
  used: number;
  limit: number; // -1 means unlimited (don't render)
}

export function UsageProgressBar({ label, used, limit }: UsageProgressBarProps) {
  // Don't render if limit is unlimited
  if (limit === -1) {
    return null;
  }

  // Calculate percentage
  const percentage = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;

  // Determine color based on utilization
  let barColor: string;
  if (percentage >= 90) {
    barColor = 'bg-error';
  } else if (percentage >= 75) {
    barColor = 'bg-warning';
  } else {
    barColor = 'bg-success';
  }

  // Format numbers with commas
  const formatNumber = (num: number) => num.toLocaleString();

  return (
    <div className="flex items-center gap-3">
      <div className="min-w-[100px] text-xs text-surface-600">{label}</div>
      <div className="flex-1 flex items-center gap-2">
        {/* Progress bar */}
        <div className="flex-1 h-1.5 bg-surface-200 rounded-full overflow-hidden">
          <div
            className={`h-full ${barColor} transition-all duration-300 rounded-full`}
            style={{ width: `${percentage}%` }}
          />
        </div>
        {/* Numbers */}
        <div className="min-w-[100px] text-xs text-surface-600 text-right font-mono">
          {formatNumber(used)} / {formatNumber(limit)}
        </div>
      </div>
    </div>
  );
}
